import { HttpMethod } from "@/types/https";
import { PublicHolidayResponseType } from "../types/public-holiday.type";
import { apiWorkchestraCall } from "../base";
import { ENDPOINT } from "../endpoints";

export const PublicHoliday = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `PublicHoliday_${stringParams}`,
    handle: (): Promise<PublicHolidayResponseType> =>
      apiWorkchestraCall<PublicHolidayResponseType>({
        params,
        url: ENDPOINT.PUBLIC_HOLIDAYS,
        method: HttpMethod.GET,
      }),
  };
};
